import { EventCard } from "./event-card";
import { Button } from "@/components/ui/button";
import { Link } from "@remix-run/react";

export function EventsByMonth({ eventsByMonth, pagination, nextUrl, prevUrl }) {
  const hasEvents = Object.keys(eventsByMonth).length > 0;

  if (!hasEvents) {
    return <p>No events found.</p>;
  }

  return (
    <>
      <div className="grid gap-3">
        {Object.keys(eventsByMonth).map((month) => {
          const events = eventsByMonth[month];
          return (
            <div key={month}>
              <h2 className="text-2xl font-semibold px-3 mt-3">{month}</h2>
              <div className="grid gap-3 mt-3">
                {events.map((event, eventIndex) => {
                  return <EventCard key={event?.id ?? `event_${eventIndex}`} event={event} orientation="horizontal" />;
                })}
              </div>
            </div>
          );
        })}
      </div>
      {/* pagination */}
      <div className="flex justify-center mt-6 gap-3">
        {pagination.previous_page && (
          <Button asChild variant="outline">
            <Link to={prevUrl}>Previous Events</Link>
          </Button>
        )}
        {pagination.next_page && (
          <Button asChild variant="outline">
            <Link to={nextUrl}>More Events</Link>
          </Button>
        )}
      </div>
    </>
  );
}
